export default __webpack_public_path__ + "static/media/mx.8b060f22.png";